import { useState, useEffect } from "react";
import BaseModal from "../base/BaseModal";
import BaseButton from "../base/BaseButton";
import { Formik } from "formik";
import BaseInput from "../base/BaseInput";
import { validateUpdateDetails } from "../../utils/validateSchema";
import { useAppDispatch, useAppSelector } from "../../store";
import { updateCustomerDetailsAction } from "../../store/slices/customer/action";
import { genderTypes, titles } from "../../data/utils";
import BaseSelect from "../base/CustomSelect";
import { toast } from "react-toastify";
import { CustomerProfile } from "../../store/slices/customer/types";
import { useNavigate } from "react-router-dom";
const UpdateDetails = ({
  isOpen,
  setOpen,
  customerDetails,
}: {
  isOpen: boolean;
  setOpen: (open: boolean) => void;
  customerDetails: CustomerProfile | null;
}) => {
  const [isProcessing, setIsProcessing] = useState(false);
  const [formValue, setFormValue] = useState({
    gender: {
      id: "",
      name: "",
    },
    title: {
      id: "",
      name: "",
    },
    mobile: "",
  });
  const [errorMsg, setErrorMsg] = useState({});
  const { currentOrganisationAccount } = useAppSelector(
    (state) => state.authReducer
  );

  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const onClose = () => {
    setOpen(false);
    setIsProcessing(false);
  };

  const setDefaultFormValues = () => {
    const defaultTitle = titles.find(
      (title) => title.name === customerDetails?.title
    );
    const defaultGender = genderTypes.find(
      (gender) => gender?.id === customerDetails?.gender
    );
    setFormValue((prevState) => ({
      ...prevState,
      gender: {
        id: defaultGender?.id || "",
        name: defaultGender?.name || "",
      },
      title: {
        id: defaultTitle?.id || "",
        name: defaultTitle?.name || "",
      },
    }));
  };

  useEffect(() => {
    setDefaultFormValues();
  }, [customerDetails]);

  const userObj = {
    firstName: customerDetails?.firstName || "",
    lastName: customerDetails?.lastName || "",
    dateOfBirth: customerDetails?.dateOfBirth
      ? customerDetails?.dateOfBirth?.split("T")[0]
      : "",
  };

  const updateCustomerDetails = async (data: {
    firstName: string;
    lastName: string;
    dateOfBirth: string | Date;
  }) => {
    setIsProcessing(true);
    const { firstName, lastName, dateOfBirth } = data;

    const payload = {
      firstName,
      lastName,
      dateOfBirth: new Date(dateOfBirth),
      userId: customerDetails?._id,
      gender: formValue?.gender?.id,
      title: formValue?.title?.name,
    };

    const resp = await dispatch(updateCustomerDetailsAction(payload));

    if (resp?.payload?.status == 200) {
      toast.success("Customer details updated successfully");
      setIsProcessing(false);
      navigate("/dashboard/customers");
      setOpen(false);
    } else {
      toast.error(resp?.payload?.message);
      setIsProcessing(false);
    }
  };

  const selectGender = (obj: { id: string; name: string }) => {
    setFormValue({ ...formValue, gender: obj });
    setErrorMsg({ ...errorMsg, genderError: "" });
  };

  const selectTitle = (obj: { id: string; name: string }) => {
    setFormValue({ ...formValue, title: obj });
    setErrorMsg({ ...errorMsg, titleError: "" });
  };

  return (
    <BaseModal
      closeModal={onClose}
      closable={true}
      visible={isOpen}
      modalSize="medium"
      styleClass={""}
      disabled={false}
      label={""}
      id={""}
      value={""}
      hasError={false}
      errorMsg={""}
      styles={""}
    >
      <div className="text-center">
        <h2 className=" font-playfair textbrandColor text-[24px] font-medium">
          Update Details
        </h2>
        <div className="transition my-6 lg:w-11/12 w-full m-auto">
          <Formik
            initialValues={userObj}
            onSubmit={updateCustomerDetails}
            validate={validateUpdateDetails}
          >
            {(formik) => {
              const {
                values,
                touched,
                handleChange,
                handleSubmit,
                errors,
                handleBlur,
              } = formik;
              return (
                <form onSubmit={handleSubmit}>
                  <div>
                    <BaseSelect
                      value={formValue.title}
                      label="Tilte"
                      name={"title"}
                      styleClass="mb-6"
                      //   hasError={!!errorMsg.titleError}
                      //   errorMsg={errorMsg.titleError}
                      onChange={selectTitle}
                      options={titles}
                      selectKey="name"
                      textClass={""}
                      filter={true}
                      showClear={false}
                      inputId={""}
                    />
                  </div>
                  <BaseInput
                    id={"firstName"}
                    value={userObj.firstName}
                    label="First Name"
                    name={"firstName"}
                    type="text"
                    hasError={Boolean(errors.firstName && touched.firstName)}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-6"
                    // errorMsg={
                    //     errors.firstName
                    //         ? errors.firstName
                    //         : undefined
                    // }
                  />
                  <BaseInput
                    id={"lastName"}
                    value={userObj.lastName}
                    label="Last Name"
                    name={"lastName"}
                    type="text"
                    hasError={Boolean(errors.lastName && touched.lastName)}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-6"
                    // errorMsg={
                    //     errors.lastName
                    //         ? errors.lastName
                    //         : undefined
                    // }
                  />
                  <div className="mb-6">
                    <BaseSelect
                      id={"gender"}
                      value={formValue.gender}
                      label="Gender"
                      name={"gender"}
                      blur={handleBlur}
                      styleClass=""
                      // hasError={!!errors.genderError}
                      // errorMsg={errors.genderError}
                      bodyStyles="mb-6"
                      onChange={selectGender}
                      options={genderTypes}
                      selectKey="name"
                    />
                  </div>
                  <BaseInput
                    id={"dateOfBirth"}
                    value={values.dateOfBirth as string}
                    label="Date of Birth"
                    name={"dateOfBirth"}
                    type="date"
                    hasError={errors.dateOfBirth && touched.dateOfBirth}
                    change={handleChange}
                    blur={handleBlur}
                    bodyStyles="mb-6"
                    errorMsg={errors.dateOfBirth}
                  />
                  <BaseButton
                    text="Update Details"
                    type="submit"
                    variant="primary"
                    styles=" w-3/5 mx-auto mt-4"
                    processing={isProcessing}
                  />
                </form>
              );
            }}
          </Formik>
        </div>
      </div>
    </BaseModal>
  );
};

export default UpdateDetails;
